import { RootReducerType } from './index';

export const refundRequest = (state = { requestsList: [], error: null, isLoading: false, status: '' }, action: any) => {
  switch (action.type) {
    case 'requests-loading':
      return { ...state, requestsList: [], isLoading: true, error: '' };
    case 'requestsList':
      return { ...state, requestsList: action.requestsList, isLoading: false };
    case 'requests-loading-failed':
      return { ...state, isLoading: false, error: action.error };
    case 'requestCreating':
      return { ...state, error: null, status: 'creating' };
    case 'requestCreated':
      return { ...state, status: 'created' };
    case 'requestCreationFailed':
      return { ...state, error: action.error, status: '' };

    case 'resetRequest':
      return { ...state, requestsList: [], error: null, status: '' };
    default:
      return state;
  }
};

export const refundRequestSelector = (state: RootReducerType) => state.refundRequest;

export default refundRequest;
